// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c1a188d1","239":"42ccd521","453":"59e3180d","455":"27ec8f30"}[chunkId] + ".chunk.js";
};